import { render } from "./Page404View.vue?vue&type=template&id=16de8a5c&scoped=true"
import script from "./Page404View.vue?vue&type=script&lang=js"
export * from "./Page404View.vue?vue&type=script&lang=js"

import "./Page404View.vue?vue&type=style&index=0&id=16de8a5c&scoped=true&lang=scss"

import exportComponent from "/Users/macbook/Documents/personal/freelance-sabdulla/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16de8a5c"]])

export default __exports__